import githubStyles from "github-markdown-css/github-markdown.css?inline"
import { css, html, LitElement, unsafeCSS } from "lit"
import { unsafeHTML } from "lit/directives/unsafe-html.js"
import MarkdownIt from "markdown-it"
import githubAlerts from "markdown-it-github-alerts"
import { parseFrontmatter } from "../utilitaireMarkdown/parseFrontmatter.js"

const mdParser = new MarkdownIt({
  html: true,
  linkify: true,
}).use(githubAlerts)

export default class PageBlog extends LitElement {
  static properties = {
    nomFichier: { type: String },
    contenuHtml: { type: String, state: true },
    estEnChargement: { type: Boolean, state: true },
  }

  static styles = css`
    ${unsafeCSS(githubStyles)}
    
    :host {
      display: block;
      padding: 16px;
    }
    
    .markdown-body {
      box-sizing: border-box;
      min-width: 200px;
      max-width: 90vw;
      margin: 0 auto;
      padding: 10px;
    }
  `
  constructor() {
    super()
    this.nomFichier = ""
    this.metadonnees = {}
    this.contenuHtml = ""
    this.estEnChargement = false
  }

  async willUpdate(changements) {
    if (changements.has("nomFichier") && this.nomFichier) {
      this.estEnChargement = true
      await this.chargerPage()
    }
  }

  async chargerPage() {
    try {
      const res = await fetch(`/content/blog/${encodeURIComponent(this.nomFichier)}.md`)
      if (!res.ok) {
        throw new Error(`Article introuvable (${res.status})`)
      }
      const markdown = await res.text()
      const { attributes, content } = parseFrontmatter(markdown)
      this.metadonnees = attributes
      this.contenuHtml = mdParser.render(content)
      this.mettreAJourBaliseMeta()
    } catch (erreur) {
      this.contenuHtml = `<p>Erreur lors du chargement de l'article : ${erreur.message}</p>`
    } finally {
      this.estEnChargement = false
    }
  }

  mettreAJourBaliseMeta() {
    const { titre, description } = this.metadonnees
    document.title = titre ? `${titre} - Echanges pokémon` : "Echanges pokémon"
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute("content", description || "Echanges pokémon")
    } else {
      const nouvelleMeta = document.createElement("meta")
      nouvelleMeta.setAttribute("name", "description")
      nouvelleMeta.setAttribute("content", description || "Echanges pokémon")
      document.head.appendChild(nouvelleMeta)
    }
  }

  render() {
    if (this.estEnChargement) {
      return html`<p>Chargement de l'article...</p>`
    }
    return html`<article class="markdown-body">${unsafeHTML(this.contenuHtml)}</article>`
  }
}
customElements.define("p-page-blog", PageBlog)
